// extracted by mini-css-extract-plugin
export default {"bodyLayout":"SimpleLayout_bodyLayout__GLqlR"};